const pl = {
    common: {
        whatsapp: 'WhatsApp',
        telegram: 'Telegram',
        phone: 'Telefon',
        email: 'Email',
        office: 'Biuro',
        availability: 'Dostępność',
        support: 'Wsparcie',
        preOrder: 'Pre-order',
        clearForm: 'Wyczyść formularz',
        sending: 'Wysyłanie...',
        select: 'Wybierz',
        closeNotification: 'Zamknij powiadomienie'
    },
    nav: {
        home: 'Start',
        about: 'O nas',
        preOrder: 'Pre-order',
        contacts: 'Kontakt',
        startPreOrder: 'Rozpocznij pre-order',
        openMenu: 'Otwórz menu',
        closeMenu: 'Zamknij menu',
        logoAria: 'KUB AUTO — strona główna',
        languageSwitcher: 'Język'
    },
    seo: {
        defaultTitle: 'KUB AUTO — pre-order aut premium w Europie',
        defaultDescription: 'Dobór, weryfikacja, zakup i dostawa aut premium w Europie z ustalonymi warunkami i bezpieczeństwem prawnym.',
        home: {
            title: 'KUB AUTO — pre-order aut premium w Europie',
            description: 'Dobór, weryfikacja, zakup i dostawa aut premium w Europie z ustalonymi warunkami i bezpieczeństwem prawnym.'
        },
        about: {
            title: 'O KUB AUTO — usługa pozyskiwania aut premium',
            description: 'Dowiedz się, jak KUB AUTO organizuje sourcing, weryfikację, umowę, logistykę i przekazanie aut premium w Europie.'
        },
        preOrder: {
            title: 'Formularz pre-order — wyślij wymagania dotyczące auta | KUB AUTO',
            description: 'Wyślij wymagania dotyczące auta premium i otrzymaj zweryfikowane oferty, jasne warunki oraz proces oparty na umowie.'
        },
        contacts: {
            title: 'Kontakt — KUB AUTO concierge',
            description: 'Skontaktuj się z KUB AUTO przez WhatsApp, Telegram lub email w sprawie konsultacji i zamówień pre-order.'
        }
    },
    home: {
        gallery: {
            kicker: 'WYBRANE SAMOCHODY',
            title: 'Realne auta premium z ostatnich realizacji',
            sub: 'To prawdziwe samochody, które niedawno pozyskaliśmy i dostarczyliśmy klientom. Każdy z nich odzwierciedla nasze standardy jakości, weryfikacji i obsługi.',
        },
        hero: {
            kicker: 'PRYWATNA USŁUGA POZYSKIWANIA AUT',
            title: 'Auta premium na indywidualne zamówienie',
            lead: 'Dobór, weryfikacja, zakup i dostawa w całej Europie — z ustalonymi warunkami i bezpieczeństwem prawnym.',
            cta: 'Rozpocznij pre-order',
            pills: ['Na podstawie umowy', 'Oficjalne bazy', 'Kompleksowa obsługa'],
            cardTitle: 'Co otrzymujesz',
            badge: 'STANDARD',
            bullets: ['Udokumentowany proces i stałe opłaty', 'Kontrola techniczna i prawna przed zakupem', 'Logistyka, odprawa, certyfikacja i przekazanie']
        },
        process: {
            title: 'Proces',
            sub: 'Jasny, udokumentowany, przewidywalny.',
            steps: [{title: 'Zapytanie', sub: 'Wymagania'}, {
                title: 'Analiza rynku',
                sub: 'Zweryfikowane źródła'
            }, {title: 'Weryfikacja', sub: 'Prawna + techniczna'}, {
                title: 'Umowa',
                sub: 'Stałe warunki'
            }, {title: 'Dostawa', sub: 'Przekazanie'}],
            ctaTitle: 'Prześlij wymagania — wrócimy ze zweryfikowanymi opcjami',
            ctaText: 'Typowy czas doboru: od kilku dni do dwóch tygodni.',
            cta: 'Rozpocznij pre-order'
        },
        trust: {
            title: 'Dlaczego klienci nam ufają',
            sub: 'Transparentność + bezpieczeństwo prawne w całej transakcji.',
            cards: [{title: 'Formalna umowa', text: 'Koszty, etapy i terminy są ustalone.'}, {
                title: 'Weryfikacja',
                text: 'Oficjalne bazy + raporty.'
            }, {title: 'Kompleksowo', text: 'Logistyka, cło, certyfikacja.'}],
            missionTitle: 'Uregulowana procedura',
            missionText: 'Dobór → weryfikacja → uzgodnienie → umowa → zakup → dostawa → przekazanie. Każdy etap jest udokumentowany.',
            cta: 'Uzyskaj konsultację'
        },
        reviewsFaq: {
            reviewsTitle: 'Opinie klientów',
            reviewsSub: 'Krótki feedback od klientów, którzy cenią przewidywalność, jasność i kontrolę.',
            reviews: [{
                quote: '„Wszystko zgadzało się z tym, co ustaliliśmy.”',
                text: 'Jasne kroki, regularne aktualizacje i brak presji. Cena i harmonogram pozostały zgodne z ustaleniami, a odbiór przebiegł sprawnie.',
                meta: 'Andrius Kazlauskas, Wilno (LT)'
            }, {
                quote: '„Na każdym etapie wiedziałem, co się dzieje.”',
                text: 'Otrzymywałem opcje z pełnymi szczegółami, wyjaśniano mi ryzyka i poprawnie prowadzono dokumenty. Bez zbędnych telefonów — tylko konkretna komunikacja.',
                meta: 'Nerijus Šimkus, Kowno (LT)'
            }, {
                quote: '„Samochód przyjechał dokładnie taki, jak opisano.”',
                text: 'Wyniki inspekcji przekazano z wyprzedzeniem, logistykę zorganizowano bez opóźnień, a dokumenty były gotowe na czas. Całościowo — profesjonalny i spokojny proces.',
                meta: 'Mārtiņš Pētersons, Ryga (LV)'
            }],
            faqTitle: 'FAQ',
            faqSub: 'Odpowiedzi na najczęstsze pytania dotyczące procesu.',
            faq: [{
                q: 'Jak rozpocząć pre-order?',
                a: 'Wyślij formularz pre-order z wymaganiami. Potwierdzimy szczegóły i rozpoczniemy dobór.'
            }, {
                q: 'Jak długo trwa dobór auta?',
                a: 'Zwykle od kilku dni do dwóch tygodni, w zależności od złożoności wymagań.'
            }, {
                q: 'Jak weryfikowane są auta?',
                a: 'Każde auto przechodzi kontrolę techniczną i prawną z użyciem oficjalnych baz oraz raportów z inspekcji.'
            }, {
                q: 'Kiedy podpisywana jest umowa?',
                a: 'Po zatwierdzeniu konkretnego auta i uzgodnieniu wszystkich warunków.'
            }, {
                q: 'Które koszty są ustalane z góry?',
                a: 'W umowie ustalane są opłata za usługę, logistyka, odprawa celna i obowiązkowe koszty.'
            }, {
                q: 'Co dzieje się po zakupie auta?',
                a: 'Organizujemy logistykę, odprawę celną, certyfikację i przygotowanie do przekazania.'
            }, {
                q: 'Kiedy otrzymam auto?',
                a: 'Po zakończeniu wszystkich procedur i weryfikacji dokumentów auto zostaje przekazane.'
            }, {
                q: 'Czy mogę odrzucić wybrane auto?',
                a: 'Tak. Dobór trwa do momentu zaakceptowania auta w pełni zgodnego z wymaganiami.'
            }, {
                q: 'Czy pracujecie z firmami i klientami prywatnymi?',
                a: 'Tak. Obsługujemy zarówno osoby prywatne, jak i firmy na podstawie formalnej umowy.'
            }, {
                q: 'W jakich krajach szukacie aut?',
                a: 'Pozyskujemy auta w całej Europie, współpracując wyłącznie ze zweryfikowanymi dostawcami i platformami aukcyjnymi.'
            }, {
                q: 'Czy dostawa i odprawa celna są wliczone?',
                a: 'Tak. Pełna logistyka, odprawa celna i certyfikacja są częścią usługi.'
            }]
        },
        finalCta: {
            kicker: 'GOTOWY, ABY ZACZĄĆ',
            title: 'Rozpocznij zgłoszenie pre-order',
            sub: 'Odpowiemy zweryfikowanymi opcjami i jasnymi warunkami.',
            cta: 'Przejdź do pre-order'
        },
    },
    about: {
        hero: {
            kicker: 'O FIRMIE',
            title: 'Auta premium pozyskiwane na indywidualne zamówienie w całej Europie',
            lead: 'Zapewniamy profesjonalny dobór, weryfikację i zakup aut premium na podstawie indywidualnych wymagań klienta, z pełnym wsparciem prawnym i logistycznym od pierwszego wyszukania do finalnego przekazania.',
            cta: 'Wyślij zgłoszenie pre-order'
        },
        overview: {
            title: 'Ogólny przegląd',
            sub: 'Nasze usługi są skierowane do klientów, którzy cenią transparentność, uporządkowany proces i bezpieczeństwo prawne.',
            cards: [{
                title: 'Zakres działalności',
                text: 'Firma specjalizuje się w wyszukiwaniu, weryfikacji i zakupie aut premium na rynku europejskim, w tym u oficjalnych dealerów, zweryfikowanych dostawców i na platformach aukcyjnych. Wszystkie etapy — od wstępnego doboru po przekazanie auta — są realizowane zgodnie z jednolitym standardem jakości i uzgodnionym harmonogramem.'
            }, {
                title: 'Kompleksowe wsparcie',
                text: 'Zapewniamy dobór auta według określonych parametrów, udokumentowaną weryfikację techniczną i prawną, ustalenie zakresu i ceny w umowie, organizację zakupu, logistyki, odprawy celnej, certyfikacji oraz przygotowania auta do finalnego odbioru.'
            }]
        },
        principles: {
            title: 'Zasady pracy',
            sub: 'Uporządkowany, udokumentowany proces z jasną odpowiedzialnością na każdym etapie.',
            cards: [{
                icon: '✓',
                title: 'Formalność i transparentność',
                text: 'Wszystkie etapy współpracy i opłaty za usługę są ustalone w umowie. Klient ma pełną jasność co do procesu, terminów i obowiązków każdej strony.'
            }, {
                icon: '🧾',
                title: 'Kompleksowa weryfikacja auta',
                text: 'Każde auto przechodzi kontrolę techniczną i prawną z użyciem oficjalnych baz, historii serwisowej oraz — w razie potrzeby — niezależnej inspekcji eksperckiej.'
            }, {
                icon: '🎯',
                title: 'Indywidualne podejście',
                text: 'Dobór auta prowadzony jest ściśle zgodnie z budżetem klienta, preferencjami i planowanym sposobem użytkowania — bez przypadkowych i nieodpowiednich ofert.'
            }, {
                icon: '🛡',
                title: 'Pełne wsparcie',
                text: 'Organizujemy zakup, logistykę, odprawę celną, certyfikację i przygotowanie auta do przekazania, minimalizując ryzyka oraz zaangażowanie klienta.'
            }]
        },
        advantages: {
            title: 'Kluczowe zalety',
            sub: 'Dlaczego klienci wybierają indywidualny format pre-order z profesjonalnym wsparciem.',
            items: ['Potwierdzona ekspertyza w segmencie aut premium', 'Współpraca wyłącznie ze zweryfikowanymi dostawcami i platformami aukcyjnymi', 'Jasno uporządkowany workflow i ścisłe dotrzymywanie uzgodnionych terminów', 'Odpowiedzialność za rezultat na każdym etapie transakcji']
        },
        mission: {
            kicker: 'MISJA',
            title: 'Zapewniać dostęp do aut premium z gwarancją jakości i bezpieczeństwa prawnego.',
            text: 'Dostarczamy uporządkowaną, transparentną i profesjonalną usługę na każdym etapie — od pierwszego doboru po finalne przekazanie auta z kompletem dokumentów.',
            ctaPrimary: 'Wyślij zgłoszenie pre-order',
            ctaSecondary: 'Skontaktuj się z nami'
        },
        process: {
            title: 'Jak działa proces pre-order',
            sub: 'Sekwencyjna procedura z określonymi etapami i punktami kontrolnymi.',
            steps: [{
                num: '01',
                title: 'Zapytanie',
                text: 'Przesyłasz parametry auta i indywidualne wymagania.'
            }, {
                num: '02',
                title: 'Dobór',
                text: 'Wyszukujemy i prezentujemy zweryfikowane opcje pasujące do twoich kryteriów.'
            }, {
                num: '03',
                title: 'Umowa',
                text: 'Wszystkie warunki, etapy i koszty usługi są ustalane kontraktowo.'
            }, {
                num: '04',
                title: 'Zakup i logistyka',
                text: 'Organizujemy zakup, dostawę, odprawę celną i certyfikację.'
            }, {
                num: '05',
                title: 'Przekazanie',
                text: 'Auto jest przygotowywane i przekazywane z kompletem dokumentów.'
            }],
            ctaPrimary: 'Wyślij zgłoszenie pre-order',
            ctaSecondary: 'Zadaj pytanie na Telegramie'
        }
    },
    contacts: {
        hero: {
            kicker: 'KONTAKT',
            title: 'Skontaktuj się z nami',
            lead: 'Najszybsza droga: WhatsApp. Jesteśmy dostępni 24/7 w sprawie konsultacji i zgłoszeń pre-order.'
        },
        primary: {title: 'KUB AUTO Concierge', emailUs: 'Napisz do nas', telegramCta: 'Wolisz Telegram? Otwórz czat →'},
        office: {
            label: 'Adres biura',
            address: 'Dzūkų g. 6a, Vilnius, 02163 Vilniaus m. sav.',
            badge: '24/7',
            hoursLabel: 'Godziny pracy',
            hoursValue: '24/7',
            supportLabel: 'Wsparcie',
            supportValue: 'WhatsApp / Email',
            preOrderLabel: 'Pre-order',
            preOrderValue: 'Proces oparty na umowie',
            openMaps: 'Otwórz w Google Maps',
            mapTitle: 'Mapa biura KUB AUTO'
        },
        form: {
            title: 'Szybka wiadomość',
            sub: 'Zostaw krótką wiadomość — odpowiemy tak szybko, jak to możliwe.',
            nameLabel: 'Twoje imię',
            namePlaceholder: 'Imię i nazwisko',
            emailLabel: 'Email',
            emailPlaceholder: 'name@example.com',
            messageLabel: 'Wiadomość',
            messagePlaceholder: 'Jakiego auta szukasz? Budżet, rocznik, przebieg, preferencje...',
            submit: 'Wyślij wiadomość',
            success: 'Wiadomość została wysłana. Wkrótce się odezwiemy.',
            error: 'Nie udało się wysłać wiadomości.'
        }
    },
    preOrder: {
        hero: {
            kicker: 'FORMULARZ PRE-ORDER',
            title: 'Prześlij wymagania dotyczące auta',
            lead: 'Przeanalizujemy zgłoszenie i wrócimy ze zweryfikowanymi opcjami oraz jasnymi warunkami.',
        },
        vehicle: {
            title: 'Dane auta',
            sub: 'Podstawowe parametry potrzebne do rozpoczęcia doboru.',
            make: 'Marka',
            makePlaceholder: 'np. BMW',
            model: 'Model',
            modelPlaceholder: 'np. X5',
            year: 'Rok',
            yearPlaceholder: 'np. 2020',
            mileage: 'Przebieg (km)',
            mileagePlaceholder: 'np. 45000',
            fuelType: 'Rodzaj paliwa',
            bodyType: 'Typ nadwozia',
            preferences: 'Dodatkowe preferencje',
            preferencesPlaceholder: 'Wersja wyposażenia, kolor, wnętrze, stan, historia użytkowania, wymagania specjalne...',
            fuelOptions: [
                { value: 'petrol', label: 'Benzyna' },
                { value: 'diesel', label: 'Diesel' },
                { value: 'hybrid', label: 'Hybryda' },
                { value: 'electric', label: 'Elektryczne' },
            ],
            bodyOptions: [
                { value: 'sedan', label: 'Sedan' },
                { value: 'wagon', label: 'Kombi' },
                { value: 'coupe', label: 'Coupe' },
                { value: 'suv', label: 'SUV' },
                { value: 'hatchback', label: 'Hatchback' },
                { value: 'other', label: 'Inne' },
            ],
        },
        buyer: {
            title: 'Dane kupującego',
            sub: 'Do umowy i komunikacji.',
            buyerType: 'Typ kupującego',
            buyerTypeOptions: [
                { value: 'individual', label: 'Osoba prywatna' },
                { value: 'company', label: 'Firma' },
            ],
            buyerName: 'Imię / Firma',
            buyerNamePlaceholder: 'Imię i nazwisko lub nazwa firmy',
            address: 'Adres',
            addressPlaceholder: 'Ulica, miasto, kraj',
            phone: 'Telefon',
            phonePlaceholder: '+370 688 03122',
            email: 'Email',
            emailPlaceholder: 'name@example.com',
            submit: 'Wyślij zgłoszenie',
            askWhatsapp: 'Zapytaj na WhatsApp',
            askTelegram: 'Zapytaj na Telegramie',
            success: 'Zgłoszenie zostało wysłane. Wkrótce się skontaktujemy.',
            error: 'Nie udało się wysłać zgłoszenia.',
        },
        validation: {
            required: 'Wymagane',
            yearFormat: 'Użyj 4 cyfr (np. 2020)',
            numbersOnly: 'Tylko cyfry',
            tooLong: 'Za długie',
            invalidPhone: 'Użyj formatu międzynarodowego, np. +37068803122',
            invalidEmail: 'Nieprawidłowy email',
            invalid: 'Nieprawidłowe',
        },
    },
    validation: {
        tooShort: 'Za krótkie',
        tooLong: 'Za długie',
        required: 'Wymagane',
        invalidEmail: 'Nieprawidłowy email',
        invalid: 'Nieprawidłowe',
        unknownError: 'Nieznany błąd'
    },
};

export default pl;
